import { queryOptions } from '@tanstack/react-query';

import { ApiService } from '@/services/api-v2';

export const assetCategoryKeys = {
  all: ['asset-categories'] as const,
  lists: () => [...assetCategoryKeys.all, 'list'] as const,
};

export const getAssetCategoriesQueryOptions = () => {
  return queryOptions({
    queryKey: assetCategoryKeys.lists(),
    queryFn: async () => (await (await ApiService.GetAssetCategories({ limit: 1000 })).json()).data,
  });
};
